import React from 'react';
import Header from './Header';
import SkipAssignmentCard from './SkipAssignmentCard';
import CharacterReportingCard from './CharacterReportingCard';
import useReports from 'state/hooks/use-reports';

const StudentCharacterReport: React.FC = () => {
  const [{ progressData, selectedCharacter, selectedStudent }] = useReports();
  return (
    <>
      <Header />
      <CharacterReportingCard
        progressData={progressData}
        character={selectedCharacter as any}
        student={selectedStudent}
      />
      <SkipAssignmentCard />
    </>
  );
};

export default StudentCharacterReport;
